var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9 bg-dark"},[_c('rbup-video-rbcom',_vm._b({staticClass:"embed-responsive-item",attrs:{"asset-id":_vm.videoId,"cornerbug":"hidden","autoplay":_vm.autoplay}},'rbup-video-rbcom',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }